import { useQueryClient } from "@tanstack/react-query";
import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import { Confirm } from "../../components/confirm";
import { deleteSublet } from "../../services/sublet";
import { useLocale } from "../../stores/locale";
import { navigateBack } from "../../utils/navigate-back";

export function SubletDelete() {
  const navigate = useNavigate();
  const locale = useLocale((state) => state);
  const queryClient = useQueryClient();
  const { id } = useParams();

  if (!id) {
    throw new Error("Sublet ID is required");
  }

  const [loading, setLoading] = useState(false);

  const closeModal = () => {
    navigateBack(navigate, "/admin/register/sublet");
  };

  return (
    <>
      <Confirm
        header={locale.get("sublet.confirmDelete")}
        loading={loading}
        onClose={closeModal}
        onConfirm={() => {
          (async () => {
            setLoading(true);
            try {
              await deleteSublet(id);
              await queryClient.invalidateQueries({ queryKey: ["sublets"] });
            } finally {
              setLoading(false);
              closeModal();
            }
          })();
        }}
      />
    </>
  );
}
